import { Popover, Tooltip } from "antd";
import React, { useCallback, useEffect } from "react";
import Avatar from "../../../../assets/customSVG/Avatar";
import { ICONS } from "../../../../assets/icons";
import { ICONSS } from "../../../../assets/icons/index1";

import EditDelete from "../../../../components/commonComponents/EditDeletePopover/EditDelete";
import { getRandomColorsBassedOnLetters } from "../../../../helper/colors";
import { textsOnly } from "../../../../helper/validation";
import { useAspSelector } from "../../../../test/jest-redux-hooks";
import ProfileInfoCard from "../../../inbox/components/profile/ProfileInfoCard";
import { TEAMS_LIST_STATUS, TEAMS_MEMBER_STATUS } from "../../constants/home";

const roleID = {
  8: "Team Leader",
  9: "Team Member",
};

const TeamsList = ({
  activeNav,
  teamsData,
  setActiveTeam,
  activeTeam,
  teamMembers,
  handleDeleteTeams,
  handleEditTeams,
  handleRemoveMember,
  handleCancelInvitation,
  editDeletePopover,
  setEditDeteletePopover,
  handleActivateTeams,
  updateScreenName,
  setInputValue,
}) => {
  const { currentAccount } = useAspSelector((state) => state?.app);
  const accountsValid =
    currentAccount?.role === "Account Owner" ||
    currentAccount?.role === "Brand Manager" ||
    currentAccount?.role === "Team Manager";

  const bodyStyle =
    "text-sm weight-medium text-[var(--font-600)] text-left pl-2";

  useEffect(() => {
    if (!activeTeam && teamsData?.length > 0) {
      setActiveTeam(teamsData[0].id);
    }
  }, [teamsData, activeTeam]);

  const leaderCount = teamMembers?.filter(
    (member) => member?.role_id === 8
  )?.length;

  const memberCount = teamMembers?.filter(
    (member) => member?.role_id === 9
  )?.length;

  const enableCount = useCallback(
    (role_id) => {
      if (role_id === 8) {
        return leaderCount > 1;
      } else if (role_id === 9) {
        return memberCount > 1;
      }
      return false;
    },
    [leaderCount, memberCount]
  );

  return (
    <div className="w-100 flex-row">
      <div
        className={`  mt-10 ${
          teamsData?.length > 0 ? "border-r-2 w-20" : "w-10"
        }`}
      >
        <div className="h-[42vh] overflow-scroll">
          {teamsData?.map((team) => (
            <div
              key={team?.id}
              onClick={() => setActiveTeam(team?.id)}
              className={`p-2  mx-2 my-3 cursor-pointer rounded-md flex justify-between items-center  capitalize ${
                activeTeam === team?.id
                  ? "bg-[var(--new-primary-bg)] text-[var(--new-primary)]"
                  : "hover:bg-gray-100 text-[var(--font-600)]"
              }`}
            >
              <div className="gap-3">
                <p className="mb-1 font15px-500">{team?.name}</p>
                <span
                  style={{
                    color: TEAMS_LIST_STATUS[team?.status]?.color,
                  }}
                  className=" py-1 b-radius-6 font14px-400"
                >
                  {TEAMS_LIST_STATUS[team?.status]?.text}
                </span>
              </div>
              <Popover
                arrow={false}
                trigger={"click"}
                open={editDeletePopover === team.id}
                onOpenChange={(isOpen) => {
                  setEditDeteletePopover(isOpen ? team.id : null);
                }}
                content={
                  <EditDelete
                    tryAgain={false}
                    showActivate={team?.status !== 8 ? false : true}
                    showDelete={false}
                    onDeleteClick={() => {
                      handleDeleteTeams(team);
                    }}
                    onEditClick={() => {
                      handleEditTeams(team);
                    }}
                    onActivateClick={() => {
                      handleActivateTeams(team);
                    }}
                  />
                }
                placement="bottom"
              >
                <p className="">&#x2022;&#x2022;&#x2022;</p>
              </Popover>
            </div>
          ))}
        </div>
      </div>
      <div className="w-80 pl-10 pt-10">
        {teamMembers?.length > 0 && (
          <div className="w-100 flex-row align-center space-between">
            <div className="new-header2">Name</div>
            <div className="new-header2 w-[6%] ">Email</div>
            <div className="new-header2 w-[3%]">Status</div>
            <div className="new-header2  w-[3%]">Role</div>
            <div className="new-header2">Screen Name</div>
            <div className="new-header2">Actions</div>
          </div>
        )}
        <div
          className={`min-w-full  overflow-y-scroll ${
            activeNav ? "h-[40vh]" : "h-[71vh]"
          }`}
          id="scrollableDiv"
        >
          {teamMembers?.length > 0 ? (
            <>
              {teamMembers?.map((l) => {
                const colors = l?.first_name
                  ? getRandomColorsBassedOnLetters(l?.first_name)
                  : "";

                return (
                  <div
                    key={l?.id}
                    className="w-full flex items-center justify-between gap-3 px-4 py-1 my-1 rounded-lg bg-white shadow-sm odd:bg-gray-50"
                  >
                    {/* Avatar */}
                    <div className="flex items-center w-[1%] min-w-[120px]">
                      {l?.first_name !== "No Name" && l?.first_name !== null ? (
                        <div
                          className="w-7 h-7 rounded-full flex justify-center items-center capitalize text-white"
                          style={{
                            background: colors?.backgroundColor,
                            color: colors?.color,
                          }}
                        >
                          {l?.first_name?.charAt(0)}
                        </div>
                      ) : (
                        <div className="w-7 h-7 rounded-full flex justify-center items-center bg-gray-300">
                          <Avatar color="#ffffff" />
                        </div>
                      )}
                      <div className="pl-2 truncate capitalize text-sm font-medium">
                        {l?.first_name || "--"}
                      </div>
                    </div>

                    {/* Email */}
                    <div className="w-[18%] truncate text-sm text-gray-700">
                      {l?.email ? (
                        l.email.length > 30 ? (
                          <Tooltip title={l.email}>{l.email}</Tooltip>
                        ) : (
                          l.email
                        )
                      ) : (
                        "--"
                      )}
                    </div>

                    {/* Status */}
                    <div className="w-[14%]">
                      <span
                        className="px-2 py-1 text-xs rounded-md"
                        style={{
                          backgroundColor:
                            TEAMS_MEMBER_STATUS[l?.status]?.background,
                          color: TEAMS_MEMBER_STATUS[l?.status]?.color,
                          border: `1px solid ${
                            TEAMS_MEMBER_STATUS[l?.status]?.border
                          }`,
                        }}
                      >
                        {TEAMS_MEMBER_STATUS[l?.status]?.text}
                      </span>
                    </div>

                    {/* Invited As */}
                    <div className="w-[15%] text-sm font-medium text-gray-600 capitalize">
                      {roleID[l?.role_id] || ""}
                    </div>

                    <div className="w-[15%]">
                      <ProfileInfoCard
                        rootClassName="w-[11vw]"
                        count={25}
                        value={l?.screen_name}
                        onInputChange={(value) => {
                          const result = textsOnly(value);
                          setInputValue((prev) => ({
                            ...prev,
                            [l.id]: result,
                          }));
                          updateScreenName(l, result);
                        }}
                        inputContainerClassName="border-[var(--border-input)] pl-5"
                      />
                    </div>

                    {/* Actions */}
                    <div className="w-[10%] flex justify-end">
                      {accountsValid ? (
                        <Popover
                          content={
                            <div className="flex flex-col p-2">
                              <div
                                className={`flex items-center gap-1 rounded hover:bg-gray-100 ${
                                  enableCount(l.role_id)
                                    ? "cursor-pointer"
                                    : "cursor-not-allowed"
                                }`}
                                onClick={() => {
                                  if (enableCount(l.role_id))
                                    handleRemoveMember(l);
                                }}
                              >
                                <img src={ICONS?.RedDeleteIcon} alt="delete" />
                                <span className="text-xs text-red-500 font-medium pr-2">
                                  Remove User
                                </span>
                              </div>
                              {l?.status === 1 && (
                                <>
                                  <div className="border-t mt-1 mb-1" />
                                  <div
                                    className="flex items-center gap-2 p-2 rounded hover:bg-gray-100 cursor-pointer"
                                    onClick={() => handleCancelInvitation(l)}
                                  >
                                    <img src={ICONS?.crmTagEdit} alt="cancel" />
                                    <span className="text-xs text-gray-700 font-medium">
                                      Cancel Invitation
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                          }
                          trigger="click"
                          arrow={false}
                          placement="bottom"
                        >
                          <div className="cursor-pointer px-2 py-3 hover:bg-gray-100 rounded-md">
                            <img src={ICONSS?.dotStyleIcon} alt="options" />
                          </div>
                        </Popover>
                      ) : (
                        <div className="cursor-not-allowed px-2 py-1 rounded-md">
                          <img
                            src={ICONSS?.dotStyleIcon}
                            alt="disabled-options"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <div className=" h-[45vh] flex flex-col items-center justify-center">
              <img src={ICONS?.noChartData} alt="noChartData" />
              <p className="text-[#616874]">There’s no data yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamsList;
